import { combineReducers } from '@reduxjs/toolkit';
import { zonoApi } from '../api/zonoApi';
import { customerInviteSlice } from '../customer-invite/customer-invite.slice';
import { toastSlice } from '../toast/toast.slice';
import { userAuthSlice } from '../user-auth/userAuth.slice';
import { agentSlice } from '../agent/slice';
import { orderDataSlice } from '../order/order-slice';
import { dateStateSlice } from '../date/date-slice';
import { productSlice } from '../product/product-slice';
import { commonDataSlice } from '../common/common-slice';
import { filtersSlice } from '../filter/filter-slice';
import { paymentSlice } from '../payment/payment-slice';
import { tourSlice } from '../tour/tour-slice';
import { conversationSlice } from '../conversations/conversations-slice';
import { fieldOpsSlice } from '../field-ops/field-ops-slice';
import { appSlice } from '../app/app.slice';
import { tripSlice } from '../trip/trip-slice';
import { configSlice } from '../config/config.slice';
import { downloadStatusSlice, offlineQueueSlice } from '../offline';
import { persistedCommonDataReducer } from '../common';
import { notificationsSlice } from '../notifications/notifications-slice';

const appReducer = combineReducers({
  [appSlice.name]: appSlice.reducer,
  [zonoApi.reducerPath]: zonoApi.reducer,
  [userAuthSlice.name]: userAuthSlice.reducer,
  [customerInviteSlice.name]: customerInviteSlice.reducer,
  [toastSlice.name]: toastSlice.reducer,
  [agentSlice.name]: agentSlice.reducer,
  [orderDataSlice.name]: orderDataSlice.reducer,
  [dateStateSlice.name]: dateStateSlice.reducer,
  [productSlice.name]: productSlice.reducer,
  [commonDataSlice.name]: persistedCommonDataReducer,
  [filtersSlice.name]: filtersSlice.reducer,
  [paymentSlice.name]: paymentSlice.reducer,
  [tourSlice.name]: tourSlice.reducer,
  [conversationSlice.name]: conversationSlice.reducer,
  [fieldOpsSlice.name]: fieldOpsSlice.reducer,
  [tripSlice.name]: tripSlice.reducer,
  [configSlice.name]: configSlice.reducer,
  [offlineQueueSlice.name]: offlineQueueSlice.reducer,
  [downloadStatusSlice.name]: downloadStatusSlice.reducer,
  [notificationsSlice.name]: notificationsSlice.reducer,
});

export default appReducer;
